<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img
                            class="part-one-title-img"
                            src="../assets/imgs/122/part-1-title.png"
                            alt=""
                        />
                        <div
                            class="part-text part-one-title"
                            style="margin-left: 0rem"
                        >
                            在一、二、三产业中，具有工艺专长、掌握高超技能，技术精湛、精益求精，严谨细致、专业敬业，长期坚守在一线岗位，并在本行业、领域内具有较高公认度和示范引领作用的一线职工代表。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-three" style="background: #fff">
                <img
                    src="../assets/imgs/122/part-2-title.png"
                    class="part-two-title-img"
                />
                <div class="main-content" style="padding: 0">
                    <div class="part-four-items">
                        颁发荣誉证书，给予入选者每人6000元的一次性奖励。
                    </div>
                </div>
            </div>
            <div class="part-three-extra">
                <img
                    src="../assets/imgs/122/part-3-title.png"
                    class="part-two-title-img"
                />
                <div
                    style="
                        font-size: 0.26rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        line-height:0.44rem;
                        text-align:left
                    "
                >
                    包括基础条件和技能条件。在符合基础条件的情况下，技能条件具备一个即可申报“新津工匠”。对在新津经济社会建设发展中做出重大贡献的技能人才，可适当放宽参评条件。
                </div>
                <div class="main-content" style="margin-top: 0.4rem">
                    <div class="part-four-title">一、基本条件</div>
                    <div class="part-four-items">
                        拥护中国共产党领导，自觉遵守宪法和法律，热爱祖国，爱岗敬业，善于创新，甘于奉献，具备优良的职业道德和职业操守。
                    </div>
                </div>
                <div class="main-content">
                    <div class="part-four-title">二、技能条件</div>
                    <div class="part-four-items">
                        （1）获得国家、省、市、县级技能荣誉称号；<br/>
                        （2）享受县级以上政府特殊津贴；<br/>
                        （3）世界技能大赛获奖选手；全国技能比赛前50名；省级技能比赛前10名；市级技能比赛前6名；县级技能比赛前3名；<br/>
                        （4）县级以上技能大师工作室、首席技师工作室、劳模和工匠人才创新工作室、职工创新工作室领军人物；<br/>
                        （5）在技术创新、攻克技术难关等方面做出突出贡献，并总结出独特的操作工艺和操作方法，产生重大经济效益或社会效益；具有丰富的实践经验和一定的理论知识，拥有高超绝技，在本单位、本行业、本领域处于领先水平，具有较高的知名度和社会影响力；<br/>
                        （6）具有一定的绝技绝活，在挖掘和传承制造工艺上做出重大贡献。擅长带领团队攻坚克难，在职工队伍中具有较高威信；在带徒传技、技能推广等方面发挥示范作用，乐于向职工传授技艺、传播理念、传授经验，引领带动职工队伍共同成长。<br/>
                        获得“大国工匠”“天府工匠”（“四川工匠”）“成都工匠”的本区一线职工申报“新津工匠”的，直接认定。<br/>
                        处于违法犯罪处罚期和违纪影响期的个人，不得参加“新津工匠”评选。<br/>
                    </div>
                </div>

            </div>
            <div class="part-four">
                <img
                    src="../assets/imgs/122/part-4-title.png"
                    class="part-two-title-img"
                />
                <div class="main-content">
                    <div class="part-four-items">
                        <div class="title-bg">申报推荐</div>
                        <div class="part-four-content1">
                            <p>
                                “新津工匠”申报推荐方式有：个人申报、企业推荐、部门（行业）推荐、镇乡（街道）和“两园一区”推荐。
                            </p>
                        </div>
                    </div>
                    <div class="part-four-items" style="border: none">
                        <div class="title-bg title-bg2">资格审核</div>
                        <div class="part-four-content1">
                            <p>
                                1. 按照“谁推荐、谁审核”的原则，由申报人所在用人单位指导填写推荐表并出具推荐意见，交由属地镇乡（街道）、“两园一区”、部门（行业）会同县总工会进行资格审核，具备资格条件的，由属地镇乡（街道）、“两园一区”、部门（行业）组织进行专业评审，评审合格后返回原单位公示3个工作日，公示无异议后出具审核意见，并形成审核推荐排序名单一并报县总工会。
                            </p>
                            <p>
                                2.县总工会对所有申报人员及其申报材料按照申报资格条件组织集中审核。
                            </p>
                        </div>
                    </div>
                    <div class="part-four-items" style="border: none">
                        <div class="title-bg title-bg3">专家评审</div>
                        <div class="part-four-content1">
                            <p>
                                1.区总工会负责组建“新津工匠”专家评审委员会；
                            </p>
                            <p>
                                2.专家评审委员会实行“一年一组建”、“ 一评一授权”；
                            </p>
                            <p>
                                3.专家评审委员会根据产业和行业申报情况分成若干评审小组，负责对申报对象进行分组审议和综合评审；
                            </p>
                            <p>
                                4.各评审小组按照评选条件对申报对象的技能水平、业绩和贡献等进行综合评价并记名打分投票，按照得分高低确定本组提名人选；
                            </p>
                            <p>
                                5.由专家评审委员会召开综合评审会议，按照评选计划、条件和工作要求等因素，综合确定“新津工匠”候选人建议名单，并报县人才工作领导小组办公室审核确认。
                            </p>
                        </div>
                    </div>
                    <div class="part-four-items" style="border: none">
                        <div class="title-bg title-bg4">社会公示</div>
                        <div class="part-four-content1">
                            <p>
                                1.通过网络、报纸等媒体对“新津工匠”候选人名单进行社会公示，接受社会监督，公示时间不少于5天；
                            </p>
                            <p>
                                2.公示期内，对公示人选有异议，经调查核实成立的，取消评选资格。
                            </p>
                        </div>
                    </div>
                    <div class="part-four-items" style="border: none">
                        <div class="title-bg title-bg5">命名</div>
                        <div class="part-four-content1">
                            <p>
                                公示无异议后，报区委人才工作领导小组审定，由区委、区政府命名。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact">
                <img
                    class="top"
                    src="./../assets/imgs/label/contact4.png"
                    alt=""
                />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-61888121">028-82485381</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        新津区总工会
                    </div>
                </div>
            </div>

            <!-- <div class="bottom-info" style="margin-top: 0.25rem">
                责任单位：成都市人力资源和社会保障局专业技术人员服务管理处
            </div>
            <div class="bottom-info" style="margin-top:0.15rem">
                咨询电话： <a href="tel:028-61888245">028-61888245</a>、<a href="tel:028-61888121">028-61888121</a>
            </div> -->
            <!-- <bottom
                    phone="028-61888245"
                    phone2="028-61888121"
                    unit="成都市人力资源和社会保障局专业技术人员服务管理处"
                ></bottom> -->
        </div>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
// import call from "../components/call.vue";

export default {
    name: "",
    data() {
        return {

        };
    },
    components: {
        // bottom,
        // call,
    },
    created() {},
    mounted() {},
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        width: 7.5rem;
        min-height: 7.2rem;
        box-sizing: border-box;
        padding-bottom: 0.3rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            min-height: 4.73rem;
            background: url(../assets/imgs/122/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                padding-bottom: 0.2rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;
                padding-bottom: 0.35rem;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: -0.18rem;
                    width: 7.03rem;
                    height: 1.37rem;
                }

                .part-one-title {
                    margin-top: 0.98rem;
                    text-align: left;
                    margin-left: 0.34rem;
                }

                .part-one-text {
                    margin-top: 0.16rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.2rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 10px;
        box-sizing: border-box;
        display: inline-block;
        position: relative;

        .part-two-content {
            margin-top: 1.2rem;
            width: 100%;
            padding: 0.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            font-size: 0.26rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;
        }
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 0.28rem;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.1rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.5rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;
            padding-bottom: 0.2rem;

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }
    }

    .part-three-extra {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 0.15rem;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .main-content {
            margin-top: 0.8rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.5rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;
            padding-bottom: 0.2rem;
            position: relative;
            // margin-bottom: 0.8rem;

            .part-four-title {
                text-align: left;
                position: absolute;
                top: 0;
                left: 50%;
                width:2.98rem;
                font-size: 0.32rem;
                background-color: #739bfeff;
                color: #fff;
                border-radius: 20px;
                text-align:center;
                padding: 0.18rem 0.2rem;
                transform: translate(-50%, -50%);
                white-space: nowrap;
            }

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        padding: 1.2rem 0.25rem 0 0.25rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.8rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.25rem;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                    white-space: nowrap;
                }

                .title-bg2 {
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                }

                .title-bg3 {
                    background: url(../assets/imgs/craft/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }

                .title-bg5 {
                    background: url(../assets/imgs/craft/part4-5.png);
                    background-size: 100% 100%;
                }

                .title-bg6 {
                    background: url(../assets/imgs/craft/part4-6.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content1 {
                    margin-bottom: 0.2rem;

                    p {
                        margin: 0.01rem;
                    }
                }
            }
        }
    }


}
</style>
